// File utility functions
import { CHAT_BLOCKED_FILE_EXTENSIONS, UNSAFE_URL_PROTOCOL_RE } from "./constants";

export function stripUnsafeChars(v) {
  const s = String(v ?? "");
  let out = "";
  for (let i = 0; i < s.length; i += 1) {
    const code = s.charCodeAt(i);
    if ((code >= 0 && code <= 31) || code === 127) continue;
    out += s[i];
  }
  return out;
}

export function fileFingerprint(file) {
  return `${file?.name || ""}::${file?.size || 0}::${file?.lastModified || 0}`;
}

export function fileExt(name) {
  const clean = String(name || "").trim();
  const dot = clean.lastIndexOf(".");
  if (dot < 0) return "";
  return clean.slice(dot + 1).toLowerCase();
}

export function isBlockedFile(file) {
  const ext = fileExt(file?.name);
  if (ext && CHAT_BLOCKED_FILE_EXTENSIONS.has(ext)) return true;

  const mime = String(file?.type || "").toLowerCase();
  if (!mime) return false;
  if (mime.includes("javascript")) return true;
  if (mime.includes("x-msdownload")) return true;
  if (mime.includes("x-msdos-program")) return true;
  if (mime.includes("x-sh")) return true;
  if (mime.includes("x-bat")) return true;
  return false;
}

export function safeExternalUrl(raw, { allowDataImage = false } = {}) {
  const s = stripUnsafeChars(raw).trim();
  if (!s) return "";
  if (UNSAFE_URL_PROTOCOL_RE.test(s)) return "";

  if (/^https?:\/\//i.test(s)) return s;
  if (/^blob:/i.test(s)) return s;
  if (allowDataImage && /^data:image\//i.test(s)) return s;

  if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(s)) return s;
  return "";
}
